module.exports = __webpack_public_path__ + "img/_ABS9765(1).0cef0414.jpg";